import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import { NewAccessesType, NewUserType } from 'types/new-user';
import { roleType } from 'v2-types/user';

export type GQLGetUser = {
  getUser: {
    is_admin: boolean;
    is_agent: boolean;
    login_email: string;
    has_user: boolean;
    party: NewUserType;
    accesses: NewAccessesType[];
  };
};

export const getUser = async () => {
  const query = gql`
    query GetUser {
      getUser {
        is_admin
        is_agent
        login_email
        party {
          _id
          username
          user_id
          kind
          name
          first_name
          last_name
          middle_name
          onboarded
          birth
          gender
          ssn
          permissions {
            kind
            element
          }
          addresses {
            _id
            state
            address
            postal_code
            street_address
          }
          emails {
            _id
            address
            kind
          }
          phones {
            _id
            number
            kind
          }
          licenses {
            _id
            state
            number
          }
          parties {
            _id
            name
            kind
          }
          notifications {
            all
          }
        }
        accesses {
          _id
          name
          kind
          authorization
        }
      }
    }
  `;

  const response = await graphQLClient()
    .request<GQLGetUser>(query);

  return response;
};

type getRolesQueryReturn = {
  getRoles: roleType[]
}

export const getRoles = async () => {
  const queryRoles = gql`
  query geRolesQuery {
    getRoles {
      _id
      description
      permissions {
        element
        kind
      }
    }
  }
`;

  const response = await graphQLClient()
    .request<getRolesQueryReturn>(queryRoles);
  return response;
};